/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Asi_Statement_TitleInputs */



/**

* @param {Home_Quotes_Asi_Statement_TitleInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const home_quotes_asi_statement_title = /** @type {((inputs?: Home_Quotes_Asi_Statement_TitleInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Asi_Statement_TitleInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Más de 110.000 firmantes, entre ellos investigadores de IA, líderes políticos, religiosos y empresariales, artistas y personajes mediáticos")
});